import ApiKeysPanel from '@cartwhl/ui/feature/ApiKeysPanel';
import Text from '@cartwhl/ui/base/TextNew';

export default function DashboardApiKeys() {
  return (
    <section className="mx-auto flex w-full max-w-(--breakpoint-lg) flex-col">
      <Text
        as="h1"
        token="display/20/medium"
        leading="headline"
        className="text-primary text-pretty"
      >
        API keys
      </Text>
      <ApiKeysPanel />
    </section>
  );
}
